/**
 * iOS 26-27 installed apps can lay the web view out short of the screen by the status bar's height
 * (iOS testing: 812 of 874 pt on an iPhone 17, from launch or after the keyboard), leaving a black
 * band under it that no page can paint. The web view still reports the home indicator's inset,
 * though its bottom edge is nowhere near it, so the tab bar wasted that much more. While the view
 * is short, the bottom inset is dropped; once WebKit lays it out full height this never matches.
 */
export function watchShortViewport() {
  const standalone = (navigator as { standalone?: boolean }).standalone === true
  if (!standalone) return
  const check = () => {
    const portrait = window.matchMedia('(orientation: portrait)').matches
    // iOS keeps screen.width/height in portrait terms whichever way the phone is held
    const full = portrait ? screen.height : screen.width
    document.documentElement.classList.toggle('fm-short-view', full - window.innerHeight > 20)
  }
  check()
  window.addEventListener('resize', check)
}
